import { render, staticRenderFns } from "./GiftGivers.vue?vue&type=template&id=4c9f3edc&scoped=true"
import script from "./GiftGivers.vue?vue&type=script&lang=js"
export * from "./GiftGivers.vue?vue&type=script&lang=js"
import style0 from "./GiftGivers.vue?vue&type=style&index=0&id=4c9f3edc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c9f3edc",
  null
  
)

export default component.exports